export default __webpack_public_path__ + "static/media/JANDOM2025.987ee93d.png";